module.exports = __webpack_public_path__ + "img/seekingsimple2.0f08049b.jpg";